import type { MembershipData } from '@/data/types';

interface MembershipApplicationsProps {
  applications: MembershipData['applications'];
}

export function MembershipApplications({ applications }: MembershipApplicationsProps) {
  return (
    <div className="card-professional">
      <h2 className="text-2xl sm:text-3xl font-display font-semibold text-primary-700 mb-6">Applications</h2>

      <div className="space-y-6">
        <p className="text-foreground/80 leading-relaxed">
          {applications.welcome}
        </p>

        <div>
          <p className="text-foreground/80 mb-4">
            To apply for membership, you must:
          </p>

          <ul className="space-y-3">
            {applications.requirements.map((requirement, index) => (
              <li key={index} className="flex items-start">
                <span className="inline-block w-2 h-2 bg-primary rounded-full mt-2 mr-3 flex-shrink-0" />
                <span className="text-foreground/80 leading-relaxed">
                  {requirement.includes('Download an application form') ? (
                    <>
                      Legibly fill out an application form and submit a non-refundable $200 application fee. This may be done at the same time as the interview.{' '}
                      <a
                        href={`/${applications.applicationFormUrl}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary hover:text-primary/80 font-medium underline"
                      >
                        Download an application form (pdf)
                      </a>
                      .
                    </>
                  ) : requirement.includes('membership meeting') ? (
                    <>
                      Attend the{' '}
                      <a
                        href={`/${applications.meetingLink}`}
                        className="text-primary hover:text-primary/80 font-medium underline"
                      >
                        membership meeting
                      </a>
                      {' '}after your interview to be introduced to the club and have your application voted on by the club members.
                    </>
                  ) : (
                    requirement
                  )}
                </span>
              </li>
            ))}
          </ul>
        </div>

        <p className="text-foreground/80 leading-relaxed">
          {applications.process}
        </p>
      </div>
    </div>
  );
}